


























































import { computed, defineComponent, onMounted, onActivated } from '@vue/composition-api';
import ComparisonViewHeader from '@/components/Navigation/ComparisonViewHeader.vue';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import VehiclesSelect from '@/components/Comparison/VehiclesSelect.vue';
import VehicleImages from '@/components/Comparison/VehicleImages.vue';
import DifferencesSwitch from '@/components/Comparison/DifferencesSwitch.vue';
import VehicleActions from '@/components/Comparison/VehicleActions.vue';
import VehicleEmptyRow from '@/components/Comparison/VehicleEmptyRow.vue';
import VehiclePropRow from '@/components/Comparison/VehiclePropRow.vue';
import VehiclePriceRow from '@/components/Comparison/VehiclePriceRow.vue';
import ApprovalSchemeRow from '@/components/Comparison/ApprovalSchemeRow.vue';
import IframeModal from '@/components/UI/IframeModal.vue';
import DeleteCarModal from '@/components/Comparison/DeleteCarModal.vue';
import OwnersRow from '@/components/Comparison/OwnersRow.vue';
import StandardTaxRow from '@/components/Comparison/StandardTaxRow.vue';
import AdditionalTaxRow from '@/components/Comparison/AdditionalTaxRow.vue';
import InsuranceRow from '@/components/Comparison/InsuranceRow.vue';
import HpiStatusRow from '@/components/Comparison/HpiStatusRow.vue';
import HpiHistoryLinkRow from '@/components/Comparison/HpiHistoryLinkRow.vue';
import VehicleRatingRow from '@/components/Comparison/VehicleRatingRow.vue';
import TechSpecSection from '@/components/Comparison/TechSpecSection.vue';
import SellerSection from '@/components/Comparison/SellerSection.vue';
import PrintLink from '@/components/Navigation/PrintLink.vue';
import UpdatesLink from '@/components/Navigation/UpdatesLink.vue';
import ToTopLink from '@/components/Navigation/ToTopLink.vue';
import IncludedOptionsModal from '@/components/Comparison/IncludedOptionsModal.vue';

export default defineComponent({
    name: 'ComparisonView',
    components: {
        IncludedOptionsModal,
        ToTopLink,
        UpdatesLink,
        PrintLink,
        SellerSection,
        TechSpecSection,
        VehicleRatingRow,
        HpiStatusRow,
        HpiHistoryLinkRow,
        InsuranceRow,
        StandardTaxRow,
        AdditionalTaxRow,
        OwnersRow,
        ApprovalSchemeRow,
        VehiclePriceRow,
        VehiclePropRow,
        VehicleEmptyRow,
        VehicleActions,
        DifferencesSwitch,
        VehicleImages,
        VehiclesSelect,
        LoadingIcon,
        ComparisonViewHeader,
        IframeModal,
        DeleteCarModal
    },
    created () {
        document.title = 'Used Cars NI Comparison';
    },
    setup () {
        const store = useStore();
        const loading = computed(() => store.state.isComparisonLoading);
        const notEmptyComparingItems = computed(() => store.getters.notEmptyComparingItems);
        const shortlistItems = computed(() => store.state.items);
        const comparingItems = computed(() => store.getters.getVisibleTickedItems);
        const years = computed(() => store.state.years);
        const tradeRegDate = computed(() => store.getters.visibleValuesOf(store.state.tradeRegDate));
        const makes = computed(() => store.state.makes);
        const models = computed(() => store.state.models);
        const variants = computed(() => store.state.variants);
        const mileages = computed(() => store.getters.visibleValuesOf(store.state.mileages));
        const transmissions = computed(() => store.getters.visibleValuesOf(store.state.transmissions));
        const fuelTypes = computed(() => store.getters.visibleValuesOf(store.state.fuelTypes));
        const doors = computed(() => store.getters.visibleValuesOf(store.state.doors));
        const engineSizes = computed(() => store.getters.visibleValuesOf(store.state.engineSizes));
        const tradeKeys = computed(() => store.getters.visibleValuesOf(store.state.tradeKeys));
        const tradeTaxBook = computed(() => store.getters.visibleValuesOf(store.state.tradeTaxBook));
        const standardTaxes = computed(() => store.getters.visibleValuesOf(store.state.standardTaxes));
        const additionalTaxes = computed(() => store.getters.visibleValuesOf(store.state.additionalTaxes));
        const insurances = computed(() => store.getters.visibleValuesOf(store.state.insurances));
        const warranties = computed(() => store.getters.visibleValuesOf(store.state.warranties));
        const stolen = computed(() => store.getters.visibleValuesOf(store.state.stolen));
        const stolenCallouts = computed(() => store.state.stolenCallouts);
        const scrapped = computed(() => store.getters.visibleValuesOf(store.state.scrapped));
        const scrappedCallouts = computed(() => store.state.scrappedCallouts);
        const writeOff = computed(() => store.getters.visibleValuesOf(store.state.writeOff));
        const writeOffCallouts = computed(() => store.state.writeOffCallouts);
        const hpiHistoryLink = computed(() => store.state.hpiHistoryLink);

        let isMounted = false;
        onMounted(async () => {
            await store.dispatch(ActionTypes.GetItemsShortInfo);
            store.dispatch(ActionTypes.InitComparisonView, store.getters.notEmptyComparingItems);
            isMounted = true;
        });

        onActivated(async () => {
            if (isMounted) {
                await store.dispatch(ActionTypes.FetchMissingComparingItems);
            }
        });

        return {
            shortlistItems,
            loading,
            comparingItems,
            makes,
            models,
            notEmptyComparingItems,
            years,
            tradeRegDate,
            variants,
            mileages,
            transmissions,
            fuelTypes,
            doors,
            engineSizes,
            tradeKeys,
            tradeTaxBook,
            standardTaxes,
            additionalTaxes,
            insurances,
            warranties,
            stolen,
            stolenCallouts,
            scrapped,
            scrappedCallouts,
            writeOff,
            writeOffCallouts,
            hpiHistoryLink
        };
    }
});
